"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.AssetRequestDialog = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _nicbaseDialogs = require("nicbase-dialogs");

var _nicbaseForms = require("nicbase-forms");

var _nicbaseTranslation = require("nicbase-translation");

var _assetRequestComponent = _interopRequireDefault(require("./asset-request-component"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var AssetRequestDialog = function AssetRequestDialog(_ref) {
  var intl = _ref.intl,
      onCancel = _ref.onCancel,
      onSave = _ref.onSave,
      tour = _ref.tour,
      isActive = _ref.isActive;
  var dialogTitle = 'widgets.tourBoard.assetRequest';

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      assetId = _useState2[0],
      setAssetId = _useState2[1];

  return /*#__PURE__*/_react["default"].createElement(_nicbaseDialogs.BasisDialog, {
    active: isActive,
    title: /*#__PURE__*/_react["default"].createElement("span", {
      className: "dialog-title-container"
    }, intl.formatMessage({
      id: dialogTitle
    })),
    content: /*#__PURE__*/_react["default"].createElement(_assetRequestComponent["default"], {
      onAssetChange: function onAssetChange(e) {
        return setAssetId(e);
      },
      tour: tour
    }),
    actions: [/*#__PURE__*/_react["default"].createElement(_nicbaseForms.KasasiButton, {
      key: "1",
      className: "action-button cancel-button",
      onClick: onCancel
    }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.assetRequest.rejectTour",
      tagName: "span"
    })), /*#__PURE__*/_react["default"].createElement(_nicbaseForms.KasasiButton, {
      key: "2",
      primary: true,
      raised: true,
      className: "action-button",
      onClick: function onClick() {
        return onSave(assetId);
      }
    }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.assetRequest.acceptTour",
      tagName: "span"
    }))],
    onRequestCancel: onCancel,
    className: "new-tour-dialog"
  });
};

exports.AssetRequestDialog = AssetRequestDialog;

var noop = function noop() {};

AssetRequestDialog.propTypes = {
  isActive: _propTypes["default"].bool.isRequired,
  onCancel: _propTypes["default"].func,
  onSave: _propTypes["default"].func,
  tour: _propTypes["default"].shape({}),
  intl: _nicbaseTranslation.intlShape.isRequired
};
AssetRequestDialog.defaultProps = {
  tour: {
    alarms: [],
    route: null
  },
  onCancel: noop,
  onSave: noop
};

var _default = (0, _nicbaseTranslation.injectIntl)(AssetRequestDialog);

exports["default"] = _default;